export default {
    values: {
        'Visualize last BHA in the current trajectory': 'Visualize last BHA in the current trajectory',
        'Visualize flowback volume during connections': 'Visualize flowback volume during connections',
        'Borehole imaging visualizer': 'Borehole imaging visualizer',
        'Visualize operational remarks': 'Visualize operational remarks',
        'Visualize well lithology per depth': 'Visualize well lithology per depth',
        'Visualize detected operation rig states': 'Visualize detected operation rig states',
        'Visualize Section view, Plan view and Survey of a well trajectory':
            'Visualize Section view, Plan view and Survey of a well trajectory',
        'Visualize Gamma ray and resistivity logs plotted against lithology and trajectory':
            'Visualize Gamma ray and resistivity logs plotted against lithology and trajectory',
        'Errors were found in the trajectory data, which can impact the rendering of the graph.':
            'Errors were found in the trajectory data, which can impact the rendering of the graph.',
        'Errors were found that can affect the rendering of the chart':
            'Errors were found that can affect the rendering of the chart',
        'View the chart anyway': 'View the chart anyway',
        'Sync tooltip': 'Sync tooltip',
        'Wellbore Stability': 'Wellbore Stability',
        'Equivalent Departure': 'Equivalent Departure',
        'True Vertical Depth': 'True Vertical Depth',
        Lithology: 'Lithology',
        Trajectory: 'Trajectory',
        'Zoom Options': 'Zoom Options',
        'Entire Well': 'Entire Well',
        Free: 'Free',
        'Follow Bit Depth': 'Follow Bit Depth'
    }
}
